import { Button, type ButtonProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function CloseButton({ children, ...props }: ButtonProps) {
  const { t } = useTranslation();

  return (
    <Button type="button" variant="text" color="grey" {...props}>
      {children ?? t('close')}
    </Button>
  );
}
